import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Enterprise } from "@ctra/api";

import { URIState } from "@routes";

interface DialogWrapperProps {
  title: string;
}

/**
 * Wrapper component for dialog page
 * @returns
 */
export const DialogPageWrapper: FC<DialogWrapperProps> = ({ title, children }) => {
  const { search, state } = useLocation<URIState>();

  useEffect(() => {
    Enterprise.history.replace({ state: { ...state, dialogPage: { title } }, search });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, search]);

  return <>{children}</>;
};
